module.exports = __webpack_public_path__ + "img/addPhoto.ea9a0e6f.svg";